import React from 'react';
import { interpolateReds, interpolateBlues } from 'd3';

import CombinedText from '../../components/CombinedText';

import HumidityDoughnut from '../../components/HumidityDoughnut';

export default function TempHum(props) {
  return (
    <CombinedText
      size={props.size}
      extraRotation={0}
      keys={['temp_last', 'hum_last']}
      renderValues={[
        temp => <text textAnchor="middle" fill={interpolateReds(temp / 80)}>{`${temp.toFixed(1)}ºF`}</text>,
        hum => <HumidityDoughnut value={hum} showLabel />,
      ]}
    />
  )
}


// WEBPACK FOOTER //
// ./src/plots/TempHum/TempHum.component.js